let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("62DUC")).then(() => parcelRequire('f0uWG'));